import { Popover } from 'antd/lib';
import './index.less';

export default Popover;



// WEBPACK FOOTER //
// ./src/elements/popover/index.js